import * as React from 'react';
import { Box, CircularProgress, Skeleton } from '@mui/material';

const ModuleLoader: React.FC = () => (
  <div className="flex items-center justify-center w-full h-full">
    <CircularProgress size="2rem" color="primary" />
  </div>
);

const DashboardLoader: React.FC = () => (
  <div className="space-y-8">
    <Box
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      className="gap-x-4"
    >
      <Skeleton variant="circular" width={96} height={96} className="flex-none" />
      <Skeleton variant="text" sx={{ fontSize: '2rem', width: '300px' }} />
    </Box>
    <Skeleton animation="wave" variant="rounded" height={450} className="rounded-xl" />
  </div>
);
export { ModuleLoader, DashboardLoader };
